import React, { useEffect, useState } from "react";

export default function InputBox({
  ControllerProps,
  dispatchItemToredux,
  defaultValue,
}) {
  const { title, minValue, maxValue, reduxKey, itemInArray, parentType } =
    ControllerProps;
  const [inputValue, setInputValue] = useState(defaultValue);
  // const { Sheetid } = currentSheet;
  // console.log(defaultValue);
  
  // console.log(title, minValue, maxValue, reduxKey, itemInArray);
  useEffect(() => {
    // console.log(defaultValue);
    setInputValue(defaultValue);
  }, [defaultValue]);
  const handleInput = (e) => {
    // console.log(e.target.value);
    const newValue = e.target.value;
    setInputValue(newValue);
    dispatchItemToredux(newValue, reduxKey);
  };
  return (
    <>
      {parentType === "CONTAINER_WITH_TOGGLE" ? (
        <div className="w-full flex items-center justify-left mt-[4px] gap-x-[2%]">
          <label
            htmlFor={reduxKey}
            className="font-light w-[25%] inline-block text-sm"
          >
            {title}
          </label>
          <input
            type="text"
            id={reduxKey}
            min={minValue}
            max={maxValue}
            value={inputValue}
            onChange={handleInput}
            onClick={() => {
              // console.log(reduxKey);
            }}
            className="rounded border-gray-200 border px-1 font-light w-[80%] focus:outline-none"
          />
        </div>
      ) : (
        <div className="w-full flex items-center justify-left border-b mt-[4px]">
          <label
            htmlFor={reduxKey}
            className="font-light w-[20%] inline-block text-sm"
          >
            {title}
          </label>
          <input
            type="text"
            id={reduxKey}
            min={minValue}
            max={maxValue}
            value={inputValue}
            onChange={handleInput}
            onClick={() => {
              // console.log(reduxKey);
            }}
            className="rounded border-gray-200 border px-1 font-light w-[24%] focus:outline-none"
          />
        </div>
      )}
    </>
  );
}
